import styled from 'styled-components';

export const AnimationContainer = styled.div.attrs(
  props => ({
    style: {
      height: props.height,
      opacity: props.opacity,
      width: props.width,
      ...props.style,
    },
  })
)`
  overflow: hidden;
`;
